import React from "react";
import VerifyEmailComponent from "../../../components/auth/verify-email/verifyEmail";

const VerifyEmail: React.FC = () => {
  return (
    <>
      <VerifyEmailComponent />
    </>
  );
};

export default VerifyEmail;
